import React from 'react'
import Navbar from './Navbar'

function Contact() {
return (
<>
    <Navbar />
    <div className="row bg-navyblue text-center d-flex justify-content-center align-items-center bg-light-custom"
        id="contact">
        <div className="col-md-6 col-lg-8">
            <h1 className="text-purple">Contact Me</h1>
            <div className="row d-flex justify-content-center align-items-center">
                <div className="col-xl-6 col-sm-12 col-md-12 text-center p-2">
                    <p className="p-3">
                        I'm open for commissioned work. You can drop in your queries and will
                        get back to you at the earliest as possible.
                    </p>
                </div>
            </div>
            <p className=''>
                <i className="fas fa-envelope fa-1x text-dark-purple" />
                &nbsp;Send me an email:<a href="mailto:social@grohit.com" className="external-link">
                    social@grohit.com
                </a>
            </p>
            <div className="social">
                <div class="social-icons mb-4 text-center">


                    <a href="https://in.linkedin.com/in/g-rohit" target="_blank" rel="noopener" name="linkedin link"
                        aria-label="linkedin" className='btn'> <i class="fab fa-linkedin fa-2x"></i></a>
                    <a href="https://www.instagram.com/developergrohit/" target="_blank" rel="noopener"
                        name="Instagram link" aria-label="Instagram" className='btn'> <i
                            class="fab fa-instagram fa-2x"></i></a>
                    <a href="https://github.com/g-rohit" target="_blank" rel="noopener" name="github link"
                        aria-label="github" className='btn'> <i class="fab fa-github fa-2x"></i> </a>
                    <a href="https://www.behance.net/g-rohit" target="_blank" rel="noopener" name="Behance link"
                        aria-label="behance" title="Behance" className='btn'>
                        <i class="fab fa-behance-square fa-2x" aria-hidden="true"></i></a>
                    <a href="https://www.freecodecamp.org/grohit" target="_blank" rel="noopener"
                        aria-label="freecodecamp" id="profile-link" className='btn'> <i
                            class="fab fa-free-code-camp fa-2x"></i>
                    </a>
                    <a href="https://codepen.io/grohit/" target="_blank" name="codepen link" rel="noopener"
                        aria-label="CodePen" className='btn'> <i class="fab fa-codepen fa-2x"></i> </a>
                    {/* <a href="https://twitter.com/developerRohit" target="_blank" rel="noopener" name="Twitter link"
                        aria-label="Twitter" className='btn'> <i class="fab fa-twitter-square fa-2x"></i> </a> */}
                </div>
            </div>
        </div>
    </div>

</>
)
}

export default Contact
